module.exports = __webpack_public_path__ + "static/img/egg_g_07.1e5f426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_07.png
// module id = tj6Z
// module chunks = 1